import React = require('react');
import { get, head } from 'lodash';

interface ITravellersOverview {
  travellers: any[];
}

export const TravellersOverview = ({ travellers }: ITravellersOverview) => {

  const leadTraveller = head(travellers);
  const leadTravellerConditions = get(leadTraveller, 'screening.meta.conditions');
  const noMedicalConditionText = 'No Medical Conditions'
  const leadName = leadTraveller.title + ' ' + leadTraveller.firstName + ' ' + leadTraveller.lastName;

  return (
    <div className={'details-overview'}>
      <div className={'details-overview-header'}>
        <div className={'d-overview-icon'}>
          <img src={require('../../MakeAChange/Images/user.svg')} width={'50px'}/>
        </div>
        <div className={'d-overview-text'}>Travellers</div>
      </div>

      <div className={'details-overview-row'}>
        <div className={'d-o-attribute'}>
          <div>{leadName}</div>
          <div className={'d-o-attribute-value'}>{leadTraveller.dob}</div>
          <div
            className={'d-o-attribute-value'}>{leadTravellerConditions ? leadTravellerConditions.join(', ') : noMedicalConditionText}</div>
        </div>
      </div>

      {travellers.length > 1 &&
        travellers.slice(1).map((traveller, index) => {
          const travellerConditions = get(traveller, 'screening.meta.conditions');
          const travellerName = traveller.title + ' ' + traveller.firstName + ' ' + traveller.lastName;
          return (
            <div className={'details-overview-row'} key={index}>
              <div className={'d-o-attribute'}>
                <div>{travellerName}</div>
                <div className={'d-o-attribute-value'}>{traveller.dob}</div>
                <div
                  className={'d-o-attribute-value'}>{travellerConditions ? travellerConditions.join(', ') : noMedicalConditionText}</div>
              </div>
            </div>
          )
        })
      }

    </div>
  )
}
